import React from 'react';
import { Pill } from '../ui';
import { MODULES } from '../../theme/tokens';

// T0 — Filtre transversal par module (axe secondaire commun à Process/Functional/API/Architecture).
// `value` = clé module sélectionnée (ou null = Tous). `onChange(key|null)`.
export const ModuleFilter = ({ value, onChange, modules = Object.keys(MODULES), withAll = true, className = '' }) => (
  <div className={`flex flex-wrap gap-2 ${className}`}>
    {withAll && (
      <Pill active={!value} onClick={() => onChange(null)}>Tous</Pill>
    )}
    {modules.map((k) => {
      const m = MODULES[k];
      return (
        <Pill key={k} active={value === k} color={m.color} onClick={() => onChange(k)}>
          {m.label}
        </Pill>
      );
    })}
  </div>
);

export default ModuleFilter;
